import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "@/contexts/auth-context";
import { identifyClarityUser } from "@/lib/clarity";

// Clarity 세션은 30분 무활동 후 갱신되므로, 그보다 짧은 주기로 재호출해
// 하루 종일 켜둔 탭의 후속 세션에도 이메일 태그가 붙도록 한다.
const REIDENTIFY_INTERVAL_MS = 5 * 60 * 1000;

/**
 * 라우트 변경 시 + 주기적으로 Clarity identify 를 재호출한다.
 * 로그인 시 1회 호출(auth-context)만으로는 세션 갱신 이후의 세션이 익명으로 남는다.
 */
export const useClarityIdentify = () => {
  const { user } = useAuth();
  const location = useLocation();

  const userId = user?.id;
  const email = user?.email;

  useEffect(() => {
    if (!userId) return;

    identifyClarityUser(userId, email);
    const intervalId = window.setInterval(
      () => identifyClarityUser(userId, email),
      REIDENTIFY_INTERVAL_MS,
    );
    return () => window.clearInterval(intervalId);
  }, [userId, email, location.pathname]);
};
